import { MapPin } from "lucide-react";
import { Eyebrow, Heading } from "./Section";
import { HOURS, BOOK_ALL } from "../data";

export const Hours = () => (
  <section id="hours" data-testid="hours" className="py-20 md:py-28 bg-black">
    <div className="max-w-4xl mx-auto px-4 sm:px-6">
      <div className="mb-10">
        <Eyebrow>Find Us</Eyebrow>
        <Heading>PAKENHAM, VIC</Heading>
      </div>

      <div className="grid md:grid-cols-2 gap-8 items-start">
        <div className="border border-white/10 rounded-xl overflow-hidden">
          {HOURS.map((h) => (
            <div key={h.day} data-testid={`hours-${h.day}`}
              className="flex items-center justify-between px-5 py-4 border-b border-white/10 last:border-0">
              <span className="font-display text-xl tracking-wide text-cream">{h.day}</span>
              <span className={`font-mono-u text-sm ${h.closed ? "text-cream/35" : "text-barber-red"}`}>{h.time}</span>
            </div>
          ))}
        </div>

        <div className="bg-charcoal border border-white/10 rounded-xl p-7">
          <div className="flex items-center gap-2 text-cream">
            <MapPin className="text-barber-red" size={20} />
            <span className="font-display text-2xl tracking-wide">Pakenham, VIC</span>
          </div>
          <p className="mt-3 text-sm text-cream/60 font-body">
            Booking Wednesday to Saturday. Exact studio address shared on confirmation after you book.
          </p>
          <a href={BOOK_ALL} data-testid="hours-book-btn" className="btn-red px-7 py-3.5 text-sm mt-6 inline-flex">BOOK NOW →</a>
        </div>
      </div>
    </div>
  </section>
);
